import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[uniconPhoneFormatter]',
})
export class PhoneFormatterDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    let formatted = input.value.replace(/\D/g, '');

    if (formatted.length > 3) {
      formatted = formatted.replace(
        /^(51)(\d{3})(\d{3})(\d{3})$/,
        '+51 $2 $3 $4',
      );
      formatted = formatted.replace(
        /^(9)(\d{2})(\d{3})(\d{3})$/,
        '+51 $2 $3 $4',
      );
    } else if (formatted.length === 2 && formatted === '51') {
      formatted = '+51';
    } else if (formatted.length === 1 && formatted === '9') {
      formatted = '+51 9';
    }

    const valueToSubmit = formatted.replace(/\D/g, '');
    this.ngControl.control?.setValue(valueToSubmit, { emitEvent: false });
    input.value = formatted;
  }
}
